import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'LoginPage',
      component: () => import('../views/Login.vue')
    },
    {
      path: '/inventory',
      name: 'InventoryPage',
      component: () => import('../views/Inventory.vue')
    },
    {
      path: '/orders',
      name: 'OrdersPage',
      component: () => import('../views/Orders.vue')
    },
    {
      path: '/add-fruit',
      name: 'AddFruitPage',
      component: () => import('../views/AddFruitPage.vue')
    },
    {
      path: '/shop-manage',
      name: 'ShopManage',
      component: () => import('../views/ShopManage.vue')
    },
    {
      path: '/qr-generator',
      name: 'QRGenerator',
      component: () => import('../views/QRGenerator.vue')
    },
    {
      path: '/orders-view',
      name: 'OrdersView',
      component: () => import('../views/OrdersView.vue')
    },
    {
      path: '/order-search',
      name: 'OrderSearch',
      component: () => import('../views/OrderSearch.vue')
    },
    {
      path: '/announcements',
      name: 'AnnouncementManage',
      component: () => import('../views/AnnouncementManage.vue')
    },
    {
      path: '/',
      redirect: '/login'
    }
  ]
});

router.beforeEach((to, from, next) => {
  const account = localStorage.getItem('account');
  const permission = Number(localStorage.getItem('permission'));

  // 如果用户已登录且访问登录页，重定向到首页
  if (to.path === '/login' && account) {
    // 已登录访问登录页，根据权限跳转到相应默认页
    if (permission === 100) return next('/orders');
    return next('/shop-manage');
  }
  
  // 如果用户未登录且访问非登录页，重定向到登录页
  if (to.path !== '/login' && !account) {
    return next('/login');
  }

  // 权限控制
  if (account) {
    // 管理员: 放行所有
    if (permission === 1) return next();

    // 二级管理员: 仅允许 /orders
    if (permission === 100) {
      if (to.path === '/orders') return next();
      return next('/orders');
    }

    // 特殊权限控制：检索订单页面仅允许权限为1或10的用户访问
    if (to.path === '/order-search') {
      if (permission === 1 || permission === 10) {
        return next();
      } else {
        this.$message.error('您没有权限访问此页面');
        return next('/shop-manage');
      }
    }

    // 其他权限: 允许 /shop-manage 和 /orders-view
    if (to.path === '/shop-manage' || to.path === '/orders-view') return next();
    return next('/shop-manage');
  }

  return next();
});

export default router;